import { FIELDS } from '@/pages/Rfp/components/RfpDetails/components/SelectedParts/constants';

const partsFields = [
  {
    field: FIELDS.PART_NUMBER,
    title: 'Part number',
  },
  {
    field: FIELDS.QTY_ON_HAND,
    title: 'Qty',
  },
  {
    field: FIELDS.CUSTOMER_PN,
    title: 'Customer PN',
  },
  {
    field: FIELDS.MANUFACTURER,
    title: 'Manufacturer',
  },
  {
    field: FIELDS.CONDITION_NAME,
    title: 'Condition',
  },
  {
    field: FIELDS.DATE_CODE,
    title: 'Date code',
  },
];

export default partsFields;
